import type { TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';
import { parseWithEndTag } from './baseParser';

const tagHandlers: Record<string, (text?: string) => ReturnType<TagParser['parse']>> = {
  table_start: () => ({ html: '<table>', consumedLength: 0 }),
  table_end: () => ({ html: '</table>', consumedLength: 0 }),
  tr_start: (text = '') => {
    const { parsedText, consumedLength } = parseWithEndTag(text, 'tr_end');
    return { html: `<tr>${parsedText}</tr>`, consumedLength };
  },
  td_start: (text = '') => {
    const { parsedText, consumedLength } = parseWithEndTag(text, 'td_end');
    return {
      html: `<td>${parsedText}</td>`,
      consumedLength,
    };
  },
};

Object.entries(tagHandlers).forEach(([tag, parse]) => {
  ParserRegistry.register({ tag, parse });
});
